var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Manager, Popper, Reference } from 'react-popper';
import { BalloonContent } from './BalloonContent';
export function Balloon(props) {
  var opened = props.opened,
      onOutsideClick = props.onOutsideClick,
      children = props.children,
      _props$modifiers = props.modifiers,
      modifiers = _props$modifiers === void 0 ? {} : _props$modifiers;
  var refTarget = useRef();
  var refBalloon = useRef();
  var refBalloonFn = useCallback(function (node) {
    if (node) {
      refBalloon.current = node;
    }
  }, []);
  useEffect(function () {
    var eventNames = ['mousedown', 'touchstart'];

    function eventCallback(event) {
      var _a, _b;

      if (opened && typeof onOutsideClick === 'function' && !((_a = refBalloon.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) && !((_b = refTarget.current) === null || _b === void 0 ? void 0 : _b.contains(event.target))) {
        onOutsideClick({
          event: event
        });
      }
    }

    eventNames.forEach(function (eventName) {
      return document.addEventListener(eventName, eventCallback, true);
    });
    return function () {
      eventNames.forEach(function (eventName) {
        return document.removeEventListener(eventName, eventCallback, true);
      });
    };
  }, [onOutsideClick, opened]);
  var renderPopper = useCallback(function (_a) {
    var _a$offsetX = _a.offsetX,
        offsetX = _a$offsetX === void 0 ? 0 : _a$offsetX,
        offsetY = _a.offsetY,
        props = __rest(_a, ["offsetX", "offsetY"]);

    var _props$placement = props.placement,
        placement = _props$placement === void 0 ? 'bottom' : _props$placement,
        _props$usePortal = props.usePortal,
        usePortal = _props$usePortal === void 0 ? true : _props$usePortal,
        opened = props.opened,
        _props$fitWidthToTarg = props.fitWidthToTarget,
        fitWidthToTarget = _props$fitWidthToTarg === void 0 ? false : _props$fitWidthToTarg,
        level = props.level;

    if (!opened) {
      return null;
    }

    var resultOffsetY = offsetY != null ? offsetY : level === 'popup' ? 17 : 4;
    var popperOptions = {
      placement: placement,
      modifiers: Object.assign({
        preventOverflow: {
          enabled: false
        },
        hide: {
          enabled: false
        },
        flip: {
          enabled: false
        },
        offset: {
          offset: "".concat(offsetX, ",").concat(resultOffsetY)
        }
      }, modifiers)
    };
    var balloonBox = React.createElement(Popper, Object.assign({}, popperOptions, {
      innerRef: refBalloonFn
    }), function (_a) {
      var _b;

      var style = _a.style,
          popperProps = __rest(_a, ["style"]);

      var additionalStyle = fitWidthToTarget ? {
        width: "".concat((_b = refTarget.current) === null || _b === void 0 ? void 0 : _b.offsetWidth, "px"),
        left: '1px'
      } : {};
      var balloonContentProps = Object.assign(Object.assign({}, props), {
        popperProps: Object.assign(Object.assign({}, popperProps), {
          style: Object.assign(Object.assign({}, style), additionalStyle)
        })
      });
      return React.createElement(BalloonContent, Object.assign({}, balloonContentProps));
    });

    if (usePortal) {
      balloonBox = ReactDOM.createPortal(balloonBox, document.body);
    }

    return balloonBox;
  }, []);
  return React.createElement(Manager, null, React.createElement(Reference, null, function (_ref) {
    var ref = _ref.ref;

    function wrappedRef(node) {
      if (node) {
        refTarget.current = node;
      }

      return ref(node);
    }

    if (children instanceof Function) {
      return children({
        ref: wrappedRef
      });
    }

    return React.createElement("span", {
      ref: wrappedRef
    }, children);
  }), renderPopper(props));
}